import { createElement, lazy } from 'react';
import { Navigate } from 'react-router';

import { urls } from '@treneo/shared/constants';
import type { RouteModule } from '@treneo/shared/router';

const CoursePage = lazy(() =>
  import('./pages/course-detail/course-page').then(module => ({ default: module.CoursePage }))
);
const CoursesPage = lazy(() =>
  import('./pages/courses-list/courses-page').then(module => ({ default: module.CoursesPage }))
);
const CourseSettingsPage = lazy(() =>
  import('./pages/course-settings/course-settings-page').then(module => ({
    default: module.CourseSettingsPage
  }))
);

export const getCoursesRouteModule = (): RouteModule => ({
  id: 'courses',
  routes: [
    {
      path: urls.homePage,
      element: createElement(CoursesPage)
    },
    {
      path: urls.createCoursePage,
      element: createElement(Navigate, { to: urls.homePage, replace: true })
    },
    {
      path: urls.coursePage(':id'),
      element: createElement(CoursePage)
    },
    {
      path: urls.courseSettingsPage(':id'),
      element: createElement(CourseSettingsPage)
    }
  ]
});
